import './App.css';
import 'react-phone-number-input/style.css'
import ru from 'react-phone-number-input/locale/ru.json'
import {styled} from "@mui/material/styles";
import PhoneInput, {isValidPhoneNumber} from 'react-phone-number-input/input'
import {useState, useEffect} from 'react'
import {Button, Typography, Input} from "@mui/material";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

const ValidationTextField = styled(TextField)({
    '& input:valid + fieldset': {
        borderColor: 'white',

        borderWidth: 2,
    },
    '& input:valid:focus + fieldset': {
        borderLeftWidth: 6,
        borderColor: 'green',
        padding: '4px !important', // override inline-style
    },
});

function App() {
    const [phone, setPhone] = useState()
    const [data, setData] = useState()
    const [code, setCode] = useState()
    const [message, setMessage] = useState(false)
    const [counter, setCounter] = useState(0);

    const recallTime = 20

    useEffect(() => {
        const timer =
            counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
        return () => clearInterval(timer);
    }, [counter]);


    const handleCode = (e) => {
        let value = e.target.value
        if ((value === '' || value >= 0) && (value.length <= 4)) setCode(value)
        if (value.length === 4) handleCheck(value)
    }


    const handleCall = () => {
        fetch('/auth/getToken?to=' + phone)
            .then(response => response.json())
            .then(data => {
            setData(data)
            setCounter(recallTime)
                setMessage(false)
            });
    }

    const handleCheck = (c) => {
        fetch(`/auth/checkToken?code=${c}`)
            .then(response => response.json())
            .then(data => {
                console.log(data);
                if (data.status === 'ok'){
                    window.location.href = data.location;
                }else{
                    setCode();
                    setMessage(data.message);
                }
                });
    }

    return (
        <Box height="100%" width="100%" display="flex" flexDirection="column" alignItems="center" justifyContent="center"  position="absolute" top={0} left={0} zIndex="tooltip">
            <Typography variant="h5" component="h2" color="white">Лайк Интернет</Typography>
            <img src="/img/wifi.png" width="40%" style={{ marginBottom: '50px', marginTop: '20px' }}/>
            {!data ?
                <>
                <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" style={{ marginBottom: '50px', fontSize: '100%' }}>
                    <Typography variant="h5" component="h2" color="white">Мобильный номер</Typography>
                    <PhoneInput
                    country="RU"
                    id="phone"
                    international
                    value={phone}
                    onChange={setPhone}
                    maxLength="16"
                    placeholder="0000"
                    withCountryCallingCode
                    style={{fontSize: '170%', textIndent: '15%', fontWeight: 'bold', width: '80%', marginTop: '20px', color: phone && isValidPhoneNumber(phone) ? '#1F990C' : 'black'}}
                    />
                </Box>
                <Box justifyContent="center">
                    <Button id="enter" variant="contained" onClick={handleCall} style={{ fontSize: '100%', color: 'white' }} disabled={phone && isValidPhoneNumber(phone) ? false : true}>Войти</Button>
                </Box>
                </>
                :
                <>
                <Typography variant="h5" component="h2" color="white">{phone}</Typography>
                    <Button id="changeNum" variant="outlined" style={{fontSize: '0.7em', color: 'greenyellow'}} onClick={e => setData(false)}>Изменить номер</Button>
                <Input
                id="verifyCode"
                label="Последние 4 цифры"
                inputProps={{ type: 'number', pattern: '[0-9]*', min: 0, max: 9999, style: {textAlign: 'center'}}}
                value={code}
                autoFocus={true}
                style={{ fontSize: '200%', width: '60%', textIndent: '15%', fontWeight: 'bold', background: 'white', marginTop: '20px', marginBottom: '20px' }}
                onChange={handleCode}
                />

                    <Typography variant="subtitle2" component="h3" color="white">Укажите последние 4 цифры звонящего номера</Typography>

                    {/*<Box> { message ? message : <Button variant="contained" onClick={handleCheck}>Подтвердить</Button>} </Box>*/}
                    <Button id="repeatCall" variant="contained"  style={{ fontSize: '100%', marginTop: '30px', color: 'white' }} onClick={handleCall} disabled={counter > 0 ? true : false}>{counter > 0 && `(${counter})`} Повторный звонок </Button>
                    { message &&  <Typography variant="subtitle2" component="h3" color="error">{message}</Typography>}
                </>
            }
                </Box>
    )
}

export default App;
